export default "__VITE_ASSET__0ff5254b__"